<span class="player-metadata">{{ stats().metaData }}</span>
<span class="slider-handle"
    ><span class="current-stats">{{ stats().currStat }}</span></span
>
